/* global __webpack_public_path__ */

const BUNDLE_FILE_RE = /(?:vb-example-component|min-skog|puck|vb-admin)\.js(?:\?|$)/;

function getRuntimePublicPath() {
  if (typeof document === "undefined") {
    return null;
  }

  if (document.currentScript?.src) {
    return new URL("./", document.currentScript.src).toString();
  }

  const scripts = document.getElementsByTagName("script");
  for (let i = scripts.length - 1; i >= 0; i -= 1) {
    const src = scripts[i]?.src || "";
    if (src.includes("/vb-example-component/umd/") || BUNDLE_FILE_RE.test(src)) {
      return new URL("./", src).toString();
    }
  }

  return null;
}

const runtimePublicPath = getRuntimePublicPath();
if (runtimePublicPath) {
  __webpack_public_path__ = runtimePublicPath;
}
